import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { BlockSelectField } from '@common/components/FormElements';
import { SelectOptionType } from 'shared-types/Common';
import { TimeSlotType } from 'shared-types/SpaPackage';
import { TimeSlotOptionHOC } from './TimeSlotOptionHOC/TimeSlotOptionHOC';

export interface TimeslotSelectorProps {
  timeslotOptions: TimeSlotType[];
  display: boolean;
  selectedTime: { label: string; value: string };
  onChange: (value: any) => void;
  clearTimeSlots: () => void;
}

type TimeslotOptionType = {
  endTime: string;
} & SelectOptionType;

const timeSlotsToOptionValues = (timeSlots: TimeSlotType[] | undefined): TimeslotOptionType[] =>
  timeSlots?.map((timeSlot) => ({
    label: `${timeSlot.startTime.split(':')[0]}:${timeSlot.startTime.split(':')[1]}`,
    value: `${timeSlot.startTime}`,
    endTime: `${timeSlot.endTime}`,
    price: timeSlot.price,
    discount: timeSlot.discount,
  })) || [];

const TimeSlotOption = (props) => <TimeSlotOptionHOC parentType="Option" {...props} />;
const TimeSlotValue = (props) => <TimeSlotOptionHOC parentType="SingleValue" {...props} />;

export const TimeslotSelector: FC<TimeslotSelectorProps> = ({
  timeslotOptions,
  display,
  selectedTime,
  onChange,
  clearTimeSlots,
}) => {
  const { t } = useTranslations();
  const onChangeTimeslot = (option: TimeslotOptionType) => {
    clearTimeSlots();
    onChange({ startTime: option.value, endTime: option.endTime });
  };

  let value = {
    ...selectedTime,
    label: selectedTime.label?.split(':').slice(0, 2).join(':'),
  };

  if (!value.value && timeslotOptions?.length) {
    value = {
      value: timeslotOptions[0].startTime,
      label: timeslotOptions[0].startTime,
    };
    onChange(timeslotOptions[0]);
  }

  if (!timeslotOptions?.length) {
    value = {
      value: '',
      label: '',
    };
  }

  return (
    <div style={{ display: display ? 'block' : 'none' }}>
      <BlockSelectField
        label={t('spa.package.arrivalTime')}
        onChange={onChangeTimeslot}
        options={timeSlotsToOptionValues(timeslotOptions)}
        value={value}
        components={{
          Option: TimeSlotOption,
          SingleValue: TimeSlotValue,
        }}
        id="change-time-slot-selector"
        placeholder={t('product.selectPlaceholder')}
        useNativeDropdownOnMobile={true}
        renderMobileOption={(option) => option.label}
      />
    </div>
  );
};
